import request from '@/router/axios'

export const addOrganDrugApi = {
  // 获取机构药品列表
  fetchOrganDrugList (query) {
    return request({
      url: '/externalDrugExamine/page',
      method: 'get',
      requestType: 'JSON',
      params: query
    })
  },
  // 获取机构药品详情
  fetchOrganDrugDetail (query) {
    return request({
      url: '/externalDrugExamine/getById',
      method: 'get',
      requestType: 'JSON',
      params: query
    })
  },
  // 新增机构药品
  createOrganDrug (data) {
    return request({
      url: '/externalDrugExamine/save',
      method: 'post',
      requestType: 'JSON',
      data
    })
  },
  // 删除机构药品
  deleteOrganDrug (data) {
    return request({
      url: '/externalDrugExamine/removeById',
      method: 'post',
      requestType: 'JSON',
      data
    })
  }
}
